import React from "react";
import { Route, withRouter } from "react-router";
import VtParamMapList from "./components/VtParamMapList";
import VtParamMapForm from "./components/VtParamMapForm";


const VtParamMap = () => {
  return (
    <>
      <Route path="/vtparam_map/list" component={withRouter(VtParamMapList)} />
      <Route path="/vtparam_map/edit/:id" component={VtParamMapForm} />
      <Route path="/vtparam_map/create" component={VtParamMapForm} />
    </>
  );
};

export default VtParamMap;
